import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './ProfilePage.css';
import { http, API_BASE } from '../lib/http';
import { createImageHandler } from '../utils/imageHandler';

// Remove the old normalizeImg function - we'll use the image handler instead

export default function ProfilePage() {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  
  // Enhanced image handler for user avatars
  const imageHandler = createImageHandler('user');

  useEffect(() => {
    const loadProfile = async () => {
      setLoading(true);
      setError('');
      try {
        const res = await http.fetch('/api/profile');
        let data = null;
        try {
          data = await res.json();
        } catch {
          // ignore JSON parse errors (e.g., empty body)
        }

        if (!res.ok) {
          const msg =
            (data && (data.message || data.error)) ||
            (res.status === 401
              ? 'Please sign in to view your profile.'
              : 'Profile not available');
          setError(msg);
        } else {
          setProfile(data || {});
        }
      } catch {
        setError('Failed to load profile');
      } finally {
        setLoading(false);
      }
    };

    loadProfile();
  }, []);

  if (loading) return <div>Loading profile...</div>;
  if (error)   return <div>{error}</div>;

  const avatarSrc = imageHandler.getUrl(profile?.avatarUrl);

  return (
    <div className="profile-page-container">
      <h1>Your Profile</h1>
      {profile ? (
        <div>
          <div className="avatar-preview">
            <img 
              src={avatarSrc} 
              alt="Avatar" 
              onError={(e) => imageHandler.handleError(e, profile?.avatarUrl)}
              onLoad={(e) => imageHandler.handleLoad(e, profile?.avatarUrl)}
            />
          </div>
          <div>
            <p>Name: {profile.name || '—'}</p>
            <p>Email: {profile.email || '—'}</p>
            <p>Phone: {profile.phone || '—'}</p>
          </div>
          <div className="profile-page-actions">
            <Link to="/delete-account" className="profile-delete-link">
              Delete account
            </Link>
          </div>
        </div>
      ) : (
        <p>Profile not available.</p>
      )}
    </div>
  );
}
